export function wrapTextNodes(node) {
  if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
    const parent = node.parentNode;
    // normalize('NFC')を使って文字と濁点を1つの文字に結合
    const text = [...node.textContent.normalize('NFC')].map(char => {
      const span = document.createElement('span');
      span.classList.add('letter');
      span.textContent = char;
      return span;
    });
    text.forEach(span => parent.insertBefore(span, node));
    parent.removeChild(node);
  } else {
    node.childNodes.forEach(child => wrapTextNodes(child));
  }
}